import React from "react";
import {campaignService} from "../../jwt/_services/xtorage/campaignService";

export const campaignProvider = {
    getOptions,
    getItem
};

async function getOptions() {
    try {
        const listItems = await campaignService.search(0, 100, {})
        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code + " - " + itemData.name,
                    label: <div><label>{itemData.code} - {itemData.name}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await campaignService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{ item.code }</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}